// import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Material-UI classes for styling
export const MatUIClasses = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  paper: {
    // marginTop: theme.spacing(3),
    width: '100%',
    overflowX: 'auto',
    boxShadow: '5px 10px 8px #888888',
    marginBottom: theme.spacing(8)
  },
  container: {
    maxHeight: 440,
    minWidth: 350,
    overflowX: 'scroll',
    overflowY: 'auto',
    padding: '0px'
  },
  focusTransparent: {
    "&:focus": {
      backgroundColor: "transparent",
      outline: "none"
    },
    "&:hover": {
      boxShadow: '3px 3px 3px #888888',
    }
  },
  genesysButton: {
    "&:focus": {
      backgroundColor: "#e4e9f0",
      outline: "none"
    },
    "&:hover": {
      boxShadow: '3px 3px 3px #888888',
    },
    marginLeft: 10,
    backgroundColor: '#e4e9f0'
  },
  tabRoot: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

export const TablePaginationStyle: React.CSSProperties | undefined = {
  margin: 0,
  top: 'auto',
  right: 'auto',
  bottom: 0,
  left: 0,
  position: 'fixed',
  backgroundColor: '#fafafa',
  minWidth: "470px",
  boxShadow: '5px 10px 8px #888888',
  borderColor: '#e4e9f0',
  borderWidth: 1,
  borderStyle: 'solid'
};

export const TablePaginationMaxWithStyle = {
  margin: 0,
  top: 'auto',
  right: 'auto',
  bottom: 0,
  left: 0,
  // position: 'fixed',
  backgroundColor: '#fafafa',
  minWidth: "470px",
  boxShadow: '5px 10px 8px #888888',
  borderColor: '#e4e9f0',
  borderWidth: 1,
  borderStyle: 'solid'
};

// Style used in the Pagination Component for Tables displayed in modal windows
export const TablePaginationStyleModal = {
  backgroundColor: '#b4e2ed'
};

export const GetStripedStyle = (index: number) => {
  return { background: index % 2 ? '#fafafa' : '#daf3fb' };
}

// export const ScrollableContainer = classes.container;

// export default matUIClasses;